var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-price price"},[_c('price-display',{attrs:{"prices":_vm.prices}}),_vm._v(" "),(_vm.hasNote)?_c('span',{staticClass:"product-price__tax-note product-price__tax-note_aud gst-note gst-note--aud"},[_vm._v("\n    Incl. GST\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }